import { render, staticRenderFns } from "./WorkBench_WordSegmentList.vue?vue&type=template&id=30d71e57&scoped=true"
import script from "./WorkBench_WordSegmentList.vue?vue&type=script&lang=js"
export * from "./WorkBench_WordSegmentList.vue?vue&type=script&lang=js"
import style0 from "./WorkBench_WordSegmentList.vue?vue&type=style&index=0&id=30d71e57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d71e57",
  null
  
)

export default component.exports